// extracted by mini-css-extract-plugin
export default {"close":"closeBtn_close__lQ4Zy","item":"closeBtn_item__+jwcE"};